import styled, { css } from "styled-components";
import { theme, fade } from "../../../../../shared/style";

const Root = styled.div``;

export default {
  Root
};
